import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputText, Btn, CustomDropdown, CustomCalendar } from '../../../../components'
import * as CicloHttp from '../../../../services/api/https/deliveries/delivery-cycle.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  getEmpresas,
  getCentraisOperacoes,
  getTipoArquivosImportacaoPorEmpresa,
  getUsuarioInfo,
} from '../../../../services/localstorage/localstorage.service'

const TYPES_CYCLE = [
  { id: 0, name: 'Cross Docking', value: 'crossdocking' },
  { id: 1, name: 'Recebimento - Estoque', value: 'recebimento' },
  { id: 2, name: 'Recebimento - Estoque - DePara', value: 'recebimento-de-para' },
]

const TYPE_RECEBIMENTO_DE_PARA = 'recebimento-de-para'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  CREATE: 'Criando ciclo de entrega',
  UPDATE: 'Atualizando ciclo de entrega',
  SUCCESS: 'Ciclo de entrega salvo com sucesso',
}

const INITIAL_STATE = {
  id: 0,
  name: '',
  created_at: '',
  deadline: '',
  company_id: 0,
  company_de: null,
  operationcenter_id: 0,
  data_operacao: '',
  file_type_id: 0,
  type: 'crossdocking',
  referencia: '',
  empresas: [],
  centrais: [],
  selectedEmpresa: '',
  selectedEmpresaDe: '',
  selectedCentral: '',
  selectedTipoCiclo: { id: 0, name: 'Cross Docking', value: 'crossdocking' },
  tiposImportacao: [],
  savedCiclo: {},
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  user_id: getUsuarioInfo().id,
}

function buildTiposImportacao(empresa) {
  if (!empresa) return []

  return getTipoArquivosImportacaoPorEmpresa(empresa.id).map(modelo => ({
    value: modelo.file_type_id,
    label: modelo.importation_file_type,
  }))
}

function getFirstTipoImportacaoId(empresa) {
  const tipos = buildTiposImportacao(empresa)
  return tipos.length ? tipos[0].value : 0
}

function ModalCicloEntrega({ dispatch, onModalClose, onModalSave, data, show }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) {
      setState(prevState => {
        const empresas = getEmpresas()
        const centrais = getCentraisOperacoes()
        const selectedEmpresa = empresas.find(e => Number(e.id) === Number(data.company_id))
        const selectedEmpresaDe = empresas.find(e => Number(e.id) === Number(data.company_de))
        const selectedCentral = centrais.find(c => Number(c.id) === Number(data.operationcenter_id))
        const selectedTipoCiclo = data.type
          ? TYPES_CYCLE.find(t => t.value === data.type)
          : INITIAL_STATE.selectedTipoCiclo
        const empresaImportacao =
          selectedTipoCiclo && selectedTipoCiclo.value === TYPE_RECEBIMENTO_DE_PARA
            ? selectedEmpresaDe
            : selectedEmpresa
        const tiposImportacao = buildTiposImportacao(empresaImportacao)
        const accessError =
          data.company_id && !selectedEmpresa
            ? 'Sem acesso a empresa cadastrada no ciclo de entrega'
            : selectedTipoCiclo &&
                selectedTipoCiclo.value === TYPE_RECEBIMENTO_DE_PARA &&
                data.company_de &&
                !selectedEmpresaDe
              ? 'Sem acesso a Empresa DE cadastrada no ciclo de entrega'
              : null

        return {
          ...prevState,
          ...data,
          empresas,
          centrais,
          selectedEmpresa: selectedEmpresa || '',
          selectedEmpresaDe: selectedEmpresaDe || '',
          selectedCentral: selectedCentral || '',
          selectedTipoCiclo,
          tiposImportacao,
          company_de: data.company_de || null,
          errorMessage: accessError,
          deadline: data.deadline !== '' ? new Date(data.deadline) : '',
          data_operacao:
            data.data_operacao !== '' && data.data_operacao ? new Date(data.data_operacao) : '',
          created_at: new Date(data.created_at),
          user_id: getUsuarioInfo().id,
        }
      })
    }
  }, [show, data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.CREATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveDeliveryCycle(
          state.name,
          state.deadline,
          state.company_id,
          state.company_de,
          state.operationcenter_id,
          state.file_type_id,
          state.data_operacao,
          state.type,
          state.user_id,
          state.referencia,
        )
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        updateDeliveryCycle(
          state.id,
          state.name,
          state.deadline,
          state.company_id,
          state.company_de,
          state.operationcenter_id,
          state.file_type_id,
          state.data_operacao,
          state.type,
          state.user_id,
          state.referencia,
        )
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedCiclo)
        setState({ ...INITIAL_STATE })
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
      if (state.errorMessage.startsWith('Sem acesso')) {
        onModalClose()
      }
    }
  }, [state.errorMessage])

  const onFormContentChange = (name, value) => {
    if (name === 'selectedEmpresa') {
      setState(prevState => {
        const isDePara = prevState.type === TYPE_RECEBIMENTO_DE_PARA
        const conflictsWithEmpresaDe = isDePara && Number(prevState.company_de) === Number(value.id)

        return {
          ...prevState,
          selectedEmpresa: value,
          company_id: value.id,
          selectedEmpresaDe: conflictsWithEmpresaDe ? '' : prevState.selectedEmpresaDe,
          company_de: conflictsWithEmpresaDe ? null : prevState.company_de,
          tiposImportacao: isDePara
            ? conflictsWithEmpresaDe
              ? []
              : prevState.tiposImportacao
            : buildTiposImportacao(value),
          file_type_id: isDePara
            ? conflictsWithEmpresaDe
              ? 0
              : prevState.file_type_id
            : getFirstTipoImportacaoId(value),
        }
      })
    } else if (name === 'selectedEmpresaDe') {
      setState(prevState => ({
        ...prevState,
        selectedEmpresaDe: value,
        company_de: value.id,
        tiposImportacao: buildTiposImportacao(value),
        file_type_id: getFirstTipoImportacaoId(value),
      }))
    } else if (name === 'selectedCentral') {
      setState(prevState => ({
        ...prevState,
        selectedCentral: value,
        operationcenter_id: value.id,
      }))
    } else if (name === 'selectedTipoImportacao') {
      setState(prevState => ({ ...prevState, file_type_id: value }))
    } else if (name === 'selectedTipoCiclo') {
      setState(prevState => {
        const isDePara = value.value === TYPE_RECEBIMENTO_DE_PARA
        return {
          ...prevState,
          selectedTipoCiclo: value,
          type: value.value,
          selectedEmpresaDe: '',
          company_de: null,
          tiposImportacao: isDePara ? [] : buildTiposImportacao(prevState.selectedEmpresa),
          file_type_id: isDePara ? 0 : getFirstTipoImportacaoId(prevState.selectedEmpresa),
        }
      })
    } else {
      setState(prevState => {
        prevState[name] = value
        return { ...prevState }
      })
    }
  }

  const onBtnSalvarClicked = state => {
    if (
      state.name === '' ||
      state.deadline === '' ||
      !state.company_id ||
      !state.operationcenter_id ||
      !state.file_type_id ||
      state.data_operacao === '' ||
      (state.type === TYPE_RECEBIMENTO_DE_PARA && !state.company_de)
    )
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Todos os campos devem ser preenchidos',
      }))
    else if (
      state.type === TYPE_RECEBIMENTO_DE_PARA &&
      Number(state.company_id) === Number(state.company_de)
    )
      setState(prevState => ({
        ...prevState,
        errorMessage: 'As empresas DE e PARA devem ser diferentes',
      }))
    else if (state.id)
      setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE }))
    else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE }))
  }

  const updateDeliveryCycle = (
    id,
    name,
    deadline,
    company_id,
    company_de,
    operationcenter_id,
    file_type_id,
    data_operacao,
    type,
    user_id,
    referencia,
  ) => {
    CicloHttp.updateDeliveryCycle({
      id,
      name,
      deadline,
      company_id,
      company_de,
      operationcenter_id,
      file_type_id,
      data_operacao,
      type,
      referencia,
    })
      .then(ciclo => {
        setState(prevState => ({
          ...prevState,
          savedCiclo: ciclo,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const saveDeliveryCycle = (
    name,
    deadline,
    company_id,
    company_de,
    operationcenter_id,
    file_type_id,
    data_operacao,
    type,
    user_id,
    referencia,
  ) => {
    CicloHttp.saveDeliveryCycle({
      name,
      deadline,
      company_id,
      company_de,
      operationcenter_id,
      file_type_id,
      data_operacao,
      type,
      user_id,
      referencia,
    })
      .then(ciclo => {
        setState(prevState => ({
          ...prevState,
          savedCiclo: ciclo,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  return (
    <CustomModal header="Ciclo de Entrega" isVisible={show} onClose={onModalClose} width={600}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Descrição :*"
            marginTop={10}
            value={state.name}
            onChange={value => onFormContentChange('name', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            optionLabel="name"
            options={state.centrais}
            value={state.selectedCentral}
            label="Central Operacional :*"
            filter
            onChange={value => onFormContentChange('selectedCentral', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            options={TYPES_CYCLE}
            label="Tipo de Ciclo :*"
            optionLabel={'name'}
            value={state.selectedTipoCiclo}
            onChange={value => onFormContentChange('selectedTipoCiclo', value)}
          />
        </div>
        {state.type === TYPE_RECEBIMENTO_DE_PARA ? (
          <React.Fragment>
            <div className="p-col-6">
              <CustomDropdown
                optionLabel="name"
                options={state.empresas.filter(
                  empresa => Number(empresa.id) !== Number(state.company_id),
                )}
                value={state.selectedEmpresaDe}
                label="Empresa DE :*"
                filter
                onChange={value => onFormContentChange('selectedEmpresaDe', value)}
              />
            </div>
            <div
              className="p-col-6"
              style={{ display: 'flex', alignItems: 'center', paddingTop: 20 }}
            >
              <span style={{ fontSize: '0.78rem', color: '#555' }}>
                Todos os produtos importados devem estar cadastrados na tela 2.2 e com as
                correspondências entre as Empresas DE e PARA criadas.
              </span>
            </div>
            <div className="p-col-6">
              <CustomDropdown
                options={state.tiposImportacao}
                label="Modelos de Importação :*"
                value={state.file_type_id}
                onChange={value => onFormContentChange('selectedTipoImportacao', value)}
              />
            </div>
            <div className="p-col-6">
              <CustomDropdown
                optionLabel="name"
                options={
                  state.selectedEmpresaDe
                    ? state.empresas.filter(
                        empresa => Number(empresa.id) !== Number(state.selectedEmpresaDe.id),
                      )
                    : state.empresas
                }
                value={state.selectedEmpresa}
                label="Empresa PARA :*"
                filter
                onChange={value => onFormContentChange('selectedEmpresa', value)}
              />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="p-col-6">
              <CustomDropdown
                optionLabel="name"
                options={state.empresas}
                value={state.selectedEmpresa}
                label="Empresa :*"
                filter
                onChange={value => onFormContentChange('selectedEmpresa', value)}
              />
            </div>
            <div className="p-col-6">
              <CustomDropdown
                options={state.tiposImportacao}
                label="Modelos de Importação :*"
                value={state.file_type_id}
                onChange={value => onFormContentChange('selectedTipoImportacao', value)}
              />
            </div>
          </React.Fragment>
        )}
        <div className="p-col-6">
          <CustomCalendar
            label="Data da Operação :*"
            value={state.data_operacao}
            onChange={value => onFormContentChange('data_operacao', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomCalendar
            label="Deadline :*"
            value={state.deadline}
            onChange={value => onFormContentChange('deadline', value)}
          />
        </div>
        <div className="p-col-12">
          <InputText
            label="Referência :"
            marginTop={10}
            value={state.referencia}
            onChange={value => onFormContentChange('referencia', value)}
          />
        </div>
        <div className="p-col-6" style={{ marginTop: 20 }}>
          <Btn onClick={() => onBtnSalvarClicked(state)}>Salvar</Btn>
        </div>
        {state.user_name && state.id && (
          <div className="p-col-6">
            <InputText
              label="Criado por:"
              value={state.user_name || ''}
              disabled={true}
              marginTop={10}
            />
          </div>
        )}
      </form>
    </CustomModal>
  )
}

export default connect()(ModalCicloEntrega)
